
import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import { Coordenada } from 'src/app/models/entities/coordenada';

@Injectable({
    providedIn: 'root'
})
export class KmlUtils {
    constructor() {
    }

    /**
     * Descarga un archivo pdf utilizando una plantilla html
     * @param orientacion  La orientacion que se le dará a las páginas, puede ser 'portrait' o 'landscape'. Utilizar TipoOrientacionEnum.
     * @param nombre  Nombre que se asignara al descargar el pdf
     */
    public descargarKml(coordenadasPolyline: Coordenada[]) {
        let coordenadas: string = coordenadasPolyline.map(
            (coordenada: Coordenada) => coordenada.longitud + "," + coordenada.latitud
        ).join(" ");
        let kml = `<?xml version="1.0" encoding="UTF-8"?>
        <kml xmlns="http://www.opengis.net/kml/2.2">
            <Document>
                <Placemark>
                    <ExtendedData></ExtendedData>
                    <Style>
                        <LineStyle>
                            <color>ff0000ff</color>
                            <width>7</width>
                        </LineStyle>
                    </Style>
                    <LineString>
                        <coordinates>${coordenadas}</coordinates>
                    </LineString>
                </Placemark>
            </Document>
        </kml>`;
        const data: Blob = new Blob([kml], { type: "application/vnd.google-earth.kml+xml" });
        FileSaver.saveAs(data, new Date().getTime().toString() + ".kml");
    }
}
